import { Logo } from '../components/Logo'
import styled from 'styled-components';

const data = [
  {ja: 'リナロール', en: 'Linalool', value: '1.02%', description: 'リナロールは、花やスパイスのような香りを持つ、植物由来の芳香性アルコールです。広く香料や化粧品業界で利用されています。リナロールはまた、抗炎症、抗菌、鎮痛作用があり、アロマセラピーで利用されることがあります。'},
  {ja: 'フェネチル', en: 'Phenethyl', value: '59.33%', description: 'フェネチルアルコールは、バラ、ジャスミン、ユリなどの花にも含まれる、芳香性アルコールです。香料や化粧品において、花の香りを補完する目的で使用されます。また、抗菌性があり、製品の防腐効果にも役立ちます。'},
  {ja: 'シトロネロール', en: 'Citronellol', value: '21.46%', description: 'シトロネロールは、シトラス系の香りを持つ芳香性アルコールで、ローズやゼラニウムなどの花の香りを持ちます。香料や化粧品に広く使用されています。'},
  {ja: 'ゲラニオール', en: 'Geraniol', value: '9.85%', description: 'ゲラニオールは、バラやゼラニウムに見られる、花の香りを持つ芳香性アルコールです。香料や化粧品において、花の香りを補完する目的で使用されます。'},
  {ja: 'オイゲノール', en: 'Eugenol', value: '1.27%', description: 'オイゲノール（ユージノールとも言う）は、クローブ、シナモン、ナツメグなどのスパイスに含まれる、芳香性化合物です。スパイシーな香りとして知られており、香料や化粧品に使用されます。'},
]

const Layout = styled.div`
  text-align: left;
  display: inline-block;
  padding: 20px;
`

const LogLayout = styled.div`
  text-align: center;
  margin: 60px 0;
`

const CenterLayout = styled.div`
  padding: 0 0 40px 0;
  @media screen and (min-width:960px) {
    width: 545px;
  }
`

const RightLayout = styled(CenterLayout)`
  @media screen and (min-width:960px) {
    margin: 0 0 0 40px;
    width: 335px;
  }
`

const NumberData = styled.td`
  padding-top: 20px;
  text-align: left;
  font-weight: bold;
`

const Description = styled.td`
  padding-bottom: 20px;
  border-bottom: solid 1px #ccc;
`

const TableHead = styled.th`
  width: 8em;
`

const TopItemLayout = styled(TableHead)`
  padding-top: 20px;
`;

const detail = [
  {title: '科名', value: 'バラ科'},
  {title: '原産国', value: 'モロッコ'},
  {title: '抽出部位', value: '花'},
  {title: '抽出方法', value: 'アブソリュート (有機溶剤抽出法)'},
  {title: '学名', value: 'rose centifolia (ロサ・ケンティフォリア)'},
]

export const RoseAbsolute = () => <Layout>
<LogLayout><Logo /></LogLayout>
<CenterLayout>
<h2>1. 使用期限</h2>
  <p>{new Date('2025-09-01T09:00:00.000Z').toLocaleDateString()}</p>
  <br></br>
<h2>2. 製品の特徴</h2>
<table>
  <tbody>
    {detail.map((item, index) => <tr key={index}>
      <TableHead>{item.title}</TableHead><td>{item.value}</td>
    </tr>)}
  </tbody>
</table>
<br></br>
<br></br>
<h2>3. 成分</h2>
<table>
  <tbody>
    {data.map((item, index) => <>
      <tr key={index}>
        <TopItemLayout>{item.ja}</TopItemLayout>
        <NumberData>{item.value}</NumberData>
      </tr>
      <tr><Description colSpan={2}>{item.description}</Description></tr>
    </>)}
  </tbody>
</table>

</CenterLayout>
<RightLayout>

</RightLayout>
</Layout>




